import { render, staticRenderFns } from "./VaultGame.vue?vue&type=template&id=f6373426&scoped=true&"
import script from "./VaultGame.vue?vue&type=script&lang=js&"
export * from "./VaultGame.vue?vue&type=script&lang=js&"
import style0 from "./VaultGame.vue?vue&type=style&index=0&id=f6373426&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6373426",
  null
  
)

export default component.exports